import Immutable from 'immutable';
import LocationsConstants from 'app/constants/LocationsConstants';

const initialState = Immutable.fromJS({
  results: [],
  distances: {},
  nearPoint: null,
  query: {},
  isFetching: false,
  systemOfMeasurement: null
});

export default function locationsSearch(state = initialState, action) {
  switch (action.type) {
    case LocationsConstants.SEARCH_LOCATIONS_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case LocationsConstants.SEARCH_LOCATIONS_SUCCESS: {
      const { results, distances, nearPoint, eventsLibraryInfo } = action.payload.locations;
      return state.merge({
        results,
        distances,
        nearPoint,
        query: action.query,
        isFetching: false,
        systemOfMeasurement: eventsLibraryInfo.systemOfMeasurement
      });
    }

    case LocationsConstants.SEARCH_LOCATIONS_FAILURE: {
      return initialState;
    }

    default:
      return state;
  }
}
